import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import Antd from 'ant-design-vue'
import store from './store'
import { ConfigProvider } from 'ant-design-vue'

const app = createApp(App)
app.use(store)
app.use(Antd)
app.use(ConfigProvider, {
    componentConfig:{
        CheckBox :{
            color: '#000'
        },
    }
})
app.use(router)
app.mount('#app')
//createApp(App).use(store).use(Antd).use(router).mount('#app')
